// extracted by mini-css-extract-plugin
export default {"toolbar":"OrderList_toolbar__9cfpP","gridContainer":"OrderList_gridContainer__AIwdV","grid":"OrderList_grid__2VS4K"};